export const ROLES = [
  {
		id: 73,
		name: 'Alumno',
    description: 'Alumno',
    active: true
	},
  {
		id: 82,
		name: 'Alumno Bachillerato',
    description: 'Alumno Bachillerato',
    active: true
	},
  {
		id: 72,
		name: 'Profesor',
    description: 'Profesor que imparte cursos',
    active: true
	},
  {
		id: 81,
		name: 'Profesor Bachillerato',
    description: '',
    active: true
	},
  {
		id: 98,
		name: 'Profesor COBACH',
    description: 'Profesor que imparte cursos',
    active: true
	},
  {
		id: 99,
		name: 'Alumno COBACH',
    description: '',
    active: true
	},
];